import { transformToISO, transformToDate } from "../utils/date.transfomers";
import hasPoBox from "../utils/pobox";

const convertToAmount = (data) => {
  if (data === null || data === undefined || data.length === 0) {
    return undefined;
  }
  return {
    amount: parseInt(data, 10),
    currency: 'USD'
  };
};

const convertNullToUndefined = (value) => value === null ? undefined : value;

export const mapToFullAppRequest = (formData) => ({
  applicant: {
    personalInformation: {
      contactInformation: {
        applicantName: {
          firstName: formData.firstName,
          middleName: convertNullToUndefined(formData.middleInitial),
          lastName: formData.lastName,
          suffix: convertNullToUndefined(formData.suffix)
        },
        mailingAddress: {
          lineOne: formData.homeAddress,
          lineTwo: convertNullToUndefined(formData.aptSuiteBldg),
          city: formData.cityTown,
          state: formData.state,
          zip: formData.zip,
          countryCode: 'USA'
        },
        isMailingAddressHasPoBox: hasPoBox(formData.homeAddress),
        permanentAddress: {
          lineOne: formData.patriotActStreetAddress1,
          lineTwo: convertNullToUndefined(formData.patriotActStreetAddress2),
          city: formData.patriotActCity,
          state: formData.patriotActState,
          zip: formData.patriotActZipcode,
          countryCode: formData.patriotActStreetAddress1 ? 'USA' : undefined
        },
        emailInformation: {
          primaryEmail: formData.email
        },
        primaryPhone: formData.phoneNumber
      },
      ssn: formData.ssn,
      dateOfBirth: transformToISO(formData.dateOfBirth),
      countryOfCitizenship: formData.usCitizen === "true" ? 'Usa' : formData.countryOfCitizenship,
      mothersMaidenName: formData.mothersMaidenName,
      isMarriedInWisconsin: 'false',
      residentialInformation: {
        residentialStatus: formData.residentStatus,
        typeOfResidence: undefined,
        yearsAtCurrentResidence: formData.yearsAtResidence,
        monthsAtCurrentResidence: formData.monthsAtResidence
      },
      employmentInformation: {
        occupation: formData.occupation,
        employerName: formData.employerName,
        yearsOfEmployment: formData.yearsAtCurrentEmployer,
        selfEmployed: formData.selfEmployed,
        sourceOfIncome: formData.sourceOfIncome
      },
      financialInformation: {
        personalAnnualIncome: convertToAmount(formData.grossAnnualIncome),
        monthlyHousingPayment: convertToAmount(formData.monthlyHousingPayment),
        totalAssets: convertToAmount(formData.totalAssets)
      }
    }
  },
  personalizedQuote: {
    termInMonths: formData.selectedQuote.termInMonths,
    apr: formData.selectedQuote.apr,
    loanAmount: convertToAmount(formData.loanAmount)
  },
  loanInformation: {
    purposeOfLoan: formData.loanPurpose,
    consolidationAmount: convertToAmount(formData.consolidationAmount)
  },
  electronicConsent: {
    id: 'electronicConsentId',
    agreed: formData.electronicConsent
  },
  termsAndConditions: {
    id: 'termsAndConditionsId',
    agreed: formData.termsAndConditions
  },
  barcaoparm: {
    barcaoform: formData.barcaoform
  },
  prospectId: formData.prospectId,
  campaignId: formData.campaignId,
  cellId: formData.cellId,
  crossSellOfferDetails: formData.cardUserToken ?
    {
      retentionCallTrackGid: formData.cardUserToken.OfferRetentionCallTrackGid,
      productId: formData.cardUserToken.OfferProductId,
      productFamilyId: formData.cardUserToken.OfferProductFamilyId,
      externalAccntId: formData.cardUserToken.ExternalAccountId
    }
    : undefined
});

export const mapToLoanApplication = (customerInfo) => ({
  prospectId: customerInfo.prospectId,
  firstName: customerInfo.applicantName.firstName,
  middleInitial: customerInfo.applicantName.middleName || "",
  lastName: customerInfo.applicantName.lastName,
  suffix: customerInfo.applicantName.suffix || "",
  grossAnnualIncome: (customerInfo.grossAnnualIncome ? customerInfo.grossAnnualIncome.amount : ""),
  ssn: customerInfo.ssn,
  dateOfBirth: transformToDate(customerInfo.dateOfBirth),
  email: customerInfo.primaryEmail,
  phoneNumber: customerInfo.primaryPhone,
  usCitizen: customerInfo.countryOfCitizenship === "US" ? "true" : "false",
  countryOfCitizenship: customerInfo.countryOfCitizenship,
  homeAddress: customerInfo.address.lineOne,
  aptSuiteBldg: customerInfo.address.lineTwo,
  cityTown: customerInfo.address.city,
  state: customerInfo.address.state,
  zip: customerInfo.address.zip,
  patriotActStreetAddress1: customerInfo.permAddr.addrLine1,
  patriotActStreetAddress2: customerInfo.permAddr.addrLine2,
  patriotActCity: customerInfo.permAddr.city,
  patriotActState: customerInfo.permAddr.stateProv,
  patriotActZipcode: customerInfo.permAddr.postalCode,
  cardUserToken: customerInfo.cardUserToken
});
